
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { Getter } from "vuex-class";
import HealthHistory from "../system-view/HealthHistory.vue";
import ObjectTypeId from "@/types/sv-data/enums/ObjectTypeIds";
import BadgeActivity from "@/components/BadgeActivity.vue";
import { UserPermissions } from "@/store/types";
import { ResponseBadgeActivityDetails } from "@/store/badge-activity/types";
import BadgeActivityApi from "@/services/api.badgeActivity.service";

@Component({
	components: {
		"health-history": HealthHistory,
		"badge-activity": BadgeActivity
	}
})
export default class MarkerInfoWindowDetails extends Vue {
	@Prop({ type: String, required: true })
    private readonly deviceTitle: string;

	@Prop({ required: true, default: null })
	private readonly objectId : number | null;

	@Prop({ required: true, default: null })
	private readonly objectTypeId : ObjectTypeId | null;

	@Getter getFeature: (featureName: string[]) => boolean;
	@Getter getPermissions: UserPermissions;

	private badgeActivitySupported: ResponseBadgeActivityDetails | null = null;

	public async mounted(): Promise<void> {
		await this.checkBadgeActivitySupport();
	}

	/**
	 *@summary feature and permission check for enabling Health History tab.
	 */
	private get showHealthHistoryTab(): boolean {
		return this.getFeature(["Map", "PopOver", "DeviceStatus"]) &&
			this.getPermissions.canViewSystemView;
	}

	private get showBadgeActivityTab(): boolean {
		return this.isBadgeActivityEnabled &&
			this.objectTypeId === ObjectTypeId.Alarm &&
			this.badgeActivitySupported &&
			this.badgeActivitySupported?.canBadgeActivity;
	}

	private get isBadgeActivityEnabled(): boolean {
		return this.getFeature(["Map", "PopOver", "BadgeActivity"]) &&
			!!this.getPermissions.canViewBadgeActivity;
	}

	private get shouldShowAnyTabs(): boolean {
		return this.showHealthHistoryTab || this.showBadgeActivityTab;
	}

	private async checkBadgeActivitySupport(): Promise<void> {
		if (this.isBadgeActivityEnabled && this.objectTypeId === ObjectTypeId.Alarm) {
			this.badgeActivitySupported = await BadgeActivityApi.badgeActivitySupported(this.objectId);
		}
	}
}
